import usePopup from '@hooks/usePopup';
import { useRouter } from 'next/router';

export default function NavSignButton() {
  const router = useRouter();
  const { closeAllPopup } = usePopup();

  const moveSignin = () => {
    closeAllPopup();
    router.push('/sign-in');
  };
  return (
    <div className="w-full h-full flex items-end">
      <button onClick={moveSignin}>Log in / Create account</button>
    </div>
  );
}
